export default "__VITE_ASSET__CztDFGED__"